import { useState } from 'react';
import * as Api from '../../../Api';
import { ZonesAndMarkers } from '../interface';

const useZonesAndMarkers = () => {
    const [data, setData] = useState<ZonesAndMarkers | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const fetchZonesAndMarkers = async (customerId: string, mapname?: string) => {

        setIsLoading(true);
        setError(null);

        try {
            const queryParams = mapname ? `?mapname=${encodeURIComponent(mapname)}` : '';
            const response = await Api.getRequest(`/geofence/data/${customerId}${queryParams}`, 'GET');

            if (response.status >= 400) {
                throw new Error(`HTTP Error: ${response.status}`);
            }

            setData(response);
            return response;

        } catch (err) {
            setError('Failed to fetch Zone and Marker data. Please contact support.');
        } finally {
            setIsLoading(false);
        }
    };

    return { data, isLoading, error, fetchZonesAndMarkers };
};

export default useZonesAndMarkers;
